import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
} from 'src/views/acihighway/manifest'
import pathMap from 'src/paths/pathMap'

class AciHighwayManifestRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.ACIHWY_MANIFEST_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.ACIHWY_MANIFEST_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.ACIHWY_MANIFEST_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.ACIHWY_MANIFEST_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}

export default AciHighwayManifestRoute
